import React, { useEffect, useRef } from 'react'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import classNames from 'classnames'
import { Emoji } from 'emoji-mart'
import { createPortal } from 'react-dom'
// evertel
import { Backdrop } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { ThemeState } from '@evertel/web/theme'

interface EmojiPickerProps {
    backdrop?: boolean|'static'
    visible: boolean
    onSelectEmoji: (emoji: {text: string}) => void
    onClose: () => void
}

const EmojiPickerModal: React.FC<EmojiPickerProps> = ({
    visible,
    onSelectEmoji,
    onClose,
    backdrop = true,
    ...otherProps
}) => {

    const pickerRef = useRef(null)
    const previouslyFocusedElement = useRef<HTMLElement | null>(null)

    const themeState = useService(ThemeState, [])

    useEffect(() => {
        if (visible) {
            previouslyFocusedElement.current = document.activeElement as HTMLElement
            setTimeout(() => {
                const emojiPicker = document.getElementById('emoji-picker')
                const emEmojiPicker = emojiPicker?.querySelector('em-emoji-picker')
                const searchInput = emEmojiPicker?.shadowRoot?.querySelector('input')

                searchInput?.focus()
            }, 100)
        } else {
            setTimeout(() => {
                if (previouslyFocusedElement.current && typeof previouslyFocusedElement.current.focus === 'function') {
                    previouslyFocusedElement.current.focus()
                    previouslyFocusedElement.current = null
                }
            }, 100)
        }
    }, [visible])

    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && visible) {
                onClose?.()
            }
        }
        document.addEventListener('keydown', handleEscape)
        return () => {
            document.removeEventListener('keydown', handleEscape)
        }
    }, [visible, onClose])

    const handleSelectEmoji = (emoji) => {
        onSelectEmoji({
            text: emoji.native
        })
    }

    return (
        <>
            {createPortal(
                <div
                    id="emoji-picker"
                    ref={pickerRef}
                    className={classNames({invisible: !visible})}>
                    <Picker
                        data={data}
                        onEmojiSelect={handleSelectEmoji}
                        //bug in picker is onClose is defined it won't open
                        onClickOutside={visible && onClose}
                        theme={themeState.theme}
                        {...otherProps}
                    />
                </div>
                , document.body
            )}
            {(typeof window !== 'undefined')
                ? backdrop && createPortal(<Backdrop visible={visible} transparent />, document.body)
                : backdrop && <Backdrop visible={visible} transparent/>}
        </>
    )
}

export { EmojiPickerModal }
